import defaults from 'lodash/defaults'

export default {
    methods: {
        updateQueryString(value) {
            return this.$router.push({ query: defaults(value, this.$route.query) });
        },
        prepareGetQueryString(object) {
            return Object.entries(object).map(([key, val]) => `${key}=${val}`).join('&');
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/query.js